import React from 'react';
import ConnectGameModal from '../Components/ConnectGameModal';
import CreateGameProfileModal from '../Components/CreateGameProfileModal';
import ConnectWalletSuccessModal from '../Components/ConnectWalletSuccessModal';
import ErrorModal from '../Components/ErrorModal';
import LinkWalletModal from '../Components/LinkWalletModal';
import { authenticateUser, updateWalletBalance } from '@profile/src/redux/actions';
import { logConnectWalletEvent } from '@profile/src/utils/analytic';
import { getPreferredWalletProviderName } from '@profile/src/utils/session';
import { useTypedDispatch, useTypedSelector } from '@profile/src/redux/utils';
import AcceptAndSignModal from '../Components/AcceptAndSignModal';
import { TestableProvider } from '@wolffun/testable-id';
import ConnectWalletCampaignModal from '../Components/ConnectWalletCampaignModal';
export const ConnectWalletContext = /*#__PURE__*/React.createContext({
  startConnectEmail: () => {},
  startShowError: () => {},
  openModal: () => {},
  closeModal: () => {},
  startSignSignature: () => {}
});

const ConnectWalletProvider = ({
  children
}) => {
  const dispatch = useTypedDispatch();
  const connectWalletCampaign = useTypedSelector(state => {
    var _state$thetanWorldCon;

    return (_state$thetanWorldCon = state.thetanWorldConfig.data) === null || _state$thetanWorldCon === void 0 ? void 0 : _state$thetanWorldCon.connectWallet;
  });
  const [modal, setModal] = React.useState();
  const [provider, setProvider] = React.useState();
  const [modalStatus, setModalStatus] = React.useState('create');
  const openModal = React.useCallback(modalName => {
    setModal(prev => ({ ...prev,
      [modalName]: true
    }));
  }, []);
  const closeModal = React.useCallback(modalName => {
    setModal(prev => ({ ...prev,
      [modalName]: false
    }));
  }, []);
  const startConnectEmail = React.useCallback(() => {
    openModal('connectAccount');
  }, [openModal]);
  const startSignSignature = React.useCallback(provider => {
    openModal('acceptAndSign');
    setProvider(provider);
  }, [openModal]);
  const startShowError = React.useCallback(() => {
    openModal('error');
  }, [openModal]);
  const context = React.useMemo(() => {
    return {
      startShowError,
      startConnectEmail,
      startSignSignature,
      modal: modal || undefined,
      openModal,
      closeModal
    };
  }, [closeModal, modal, openModal, startConnectEmail, startShowError, startSignSignature]);
  return /*#__PURE__*/React.createElement(ConnectWalletContext.Provider, {
    value: context
  }, children, (modal === null || modal === void 0 ? void 0 : modal.connectEmail) && /*#__PURE__*/React.createElement(TestableProvider, {
    testId: modalStatus === 'create' ? 'create-account' : 'link-account'
  }, /*#__PURE__*/React.createElement(CreateGameProfileModal, {
    key: modalStatus,
    isCreateAccount: modalStatus === 'create',
    onClickChangeStatus: isCreate => {
      setModalStatus(isCreate ? 'create' : 'link');
    },
    onCreateSuccess: () => {
      closeModal('connectEmail');
      openModal('connectWallet');
    },
    onClose: () => closeModal('connectEmail')
  })), (modal === null || modal === void 0 ? void 0 : modal.connectWalletSuccess) && /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "awesome"
  }, /*#__PURE__*/React.createElement(ConnectWalletSuccessModal, {
    isCreateAccount: modalStatus === 'create',
    onClose: async () => {
      const user = await dispatch(authenticateUser());
      const {
        thetaBalance,
        thgBalance
      } = await dispatch(updateWalletBalance());
      closeModal('connectWalletSuccess');
      const provider = await getPreferredWalletProviderName();

      if (provider && user && thetaBalance && thgBalance) {
        logConnectWalletEvent({
          provider,
          THC: thetaBalance,
          THG: thgBalance,
          userId: user.id,
          walletAddress: user.address,
          email: user.email
        });
      }

      connectWalletCampaign && openModal('connectWalletCampaign');
    }
  })), (modal === null || modal === void 0 ? void 0 : modal.connectAccount) && /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "game-account"
  }, /*#__PURE__*/React.createElement(ConnectGameModal, {
    onClickCreateAccount: () => {
      setModalStatus('create');
      openModal('connectEmail');
    },
    onClickLinkAccount: () => {
      setModalStatus('link');
      openModal('connectEmail');
    },
    onClose: () => closeModal('connectAccount')
  })), (modal === null || modal === void 0 ? void 0 : modal.error) && /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "oops"
  }, /*#__PURE__*/React.createElement(ErrorModal, {
    onClose: () => closeModal('error')
  })), (modal === null || modal === void 0 ? void 0 : modal.connectWallet) && /*#__PURE__*/React.createElement(LinkWalletModal, {
    isCreateAccount: modalStatus === 'create',
    onSuccess: () => {
      closeModal('connectWallet');
      openModal('connectWalletSuccess');
    },
    onClose: () => closeModal('connectWallet')
  }), (modal === null || modal === void 0 ? void 0 : modal.acceptAndSign) && provider && /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "connect"
  }, /*#__PURE__*/React.createElement(AcceptAndSignModal, {
    onError: () => {
      closeModal('acceptAndSign');
      startShowError();
    },
    provider: provider,
    onClose: () => closeModal('acceptAndSign')
  })), (modal === null || modal === void 0 ? void 0 : modal.connectWalletCampaign) && /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "connectWalletCampaign"
  }, /*#__PURE__*/React.createElement(ConnectWalletCampaignModal, {
    onClose: () => closeModal('connectWalletCampaign')
  })));
};

export const useConnectWalletContext = () => {
  const {
    startConnectEmail,
    startShowError,
    startSignSignature
  } = React.useContext(ConnectWalletContext);
  return {
    startConnectEmail,
    startShowError,
    startSignSignature
  };
};
export default ConnectWalletProvider;